import moment from 'moment';
import React from 'react';
import showdown from 'showdown';

import '../styles/post.css';

export default function Post({ content, title, day }) {
  return (<div className='post'>
    <h1>{title}</h1>
    <span className='byline'>{day ? moment(day).format('MMMM Do YYYY') : ''}</span>
    <div dangerouslySetInnerHTML={{__html: new showdown.Converter().makeHtml(content)}} />
  </div>);
}



// WEBPACK FOOTER //
// ./src/components/Post.js